import React, { useContext, useState } from "react";
import { View, Text, Keyboard, ActivityIndicator } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import { NavigationProp } from "@react-navigation/native";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppColors } from "../../../../utility/AppColors";
import CommonTextInputWeb from "../../../../common/CommonTextInputWeb";
import { toast } from "react-toastify";
import { ShowLoader } from "../../../../common/ShowLoader";
import { AuthContext } from "../../../../context/AuthContext";
import { base_url, endpoints } from "../../../../Api/configs";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { storeLoginData } from "../../../../utility/AppStoreData";
import { DEVICE_SIZES } from "rn-responsive-styles";
import { AppImages } from "../../../../utility/AppImages";
import { getUserLocationDetails } from "../../../../common/getLocation";
import { TouchableWithoutFeedback } from "react-native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";
import { parseResponseBody } from "../../../../services/apiClient";

interface LoginFormProps {
  styles: any;
  username: string;
  setUserName: (username: string) => void;
  password: string;
  setPassword: (password: string) => void;
  onCloseClick: () => void;
  navigation: NavigationProp<any>;
  showLoader: boolean;
  setShowLoader: (showLoader: boolean) => void;
  onLoginSuccess: () => void;
  deviceSize: DEVICE_SIZES;
  setModalType: (type: string) => void;
}

const LoginForm: React.FC<LoginFormProps> = ({
  styles,
  username,
  setUserName,
  password,
  setPassword,
  onCloseClick,
  navigation,
  showLoader,
  setShowLoader,
  onLoginSuccess,
  deviceSize,
  setModalType,
}) => {
  // const { setModalType } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const checkValidation = (): boolean => {
    if (username === "") {
      toast.error("Please Enter Username");
      return false;
    } else if (password === "") {
      toast.error("Please Enter Password");
      return false;
    }
    return true;
  };

  const userLoginAPI = async () => {
    if (!checkValidation()) {
      return;
    }

    setShowLoader(true);

    const body = {
      username,
      password,
    };

    try {
      const response = await fetch(base_url + endpoints.auth.login, {
        mode: "cors",
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username,
          password,
        }),
      });
      let data = await response.json();
      data = parseResponseBody(data);
      setShowLoader(false);

      if (data.statusCode === 200 || data.statusCode === 201) {
        toast.success("Login Successful");
        await AsyncStorage.setItem("username", username);
        await storeLoginData(data.body);
        await getUserLocationDetails();
        onLoginSuccess();
      } else {
        toast.error(data.body.error || "Login Failed");
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };

  return (
    <View
      style={{
        backgroundColor: AppColors.black_121212,
        width:
          deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
            ? "25%"
            : deviceSize === DEVICE_SIZES.SM ||
              deviceSize === DEVICE_SIZES.MD ||
              deviceSize === DEVICE_SIZES.LG
            ? "60%"
            : "100%",
      }}
    >
      <TouchableWithoutFeedback>
        <View
          style={[
            {
              paddingHorizontal:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "5%"
                  : "3%",
              paddingVertical:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "5%"
                  : "3%",
              borderWidth: 1,
              borderColor: AppColors.white_B7C0CD,
              borderRadius: 8,
            },
          ]}
        >
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_32,
              {
                color: AppColors.white,
                marginVertical: 20,
              },
            ]}
          >
            Sign In
          </Text>

          <CommonTextInputWeb
            placeholder="UserName"
            mainStyle={[styles.inputStyle]}
            inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
            prefixIconVisibility={false}
            onChangeText={setUserName}
            isPassword={false}
            value={username}
            onSubmitEditing={() => {
              Keyboard.dismiss();
            }}
            autoCapitalize="none"
            maxLength={50}
            isRequired={true}
          />

          <CommonTextInputWeb
            placeholder="Password"
            mainStyle={[styles.inputStyle]}
            inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
            prefixIconVisibility={false}
            onChangeText={setPassword}
            isPassword={true}
            value={password}
            secureTextEntry={showPassword ? false : true}
            onSubmitEditing={() => {
              Keyboard.dismiss();
              userLoginAPI();
            }}
            autoCapitalize="none"
            maxLength={50}
            isRequired={true}
            onPressEyeIcon={() => {
              setShowPassword(!showPassword);
            }}
            rightIcon={showPassword ? AppImages.icEye : AppImages.icEyeClose}
            showEyeIcon={true}
            rightIconStyle={{ width: 20, height: 20 }}
          />

          <TouchableOpacity
            onPress={() => {
              navigateToScreen(navigation, AppScreens.ResetPasswordWebScreen);
            }}
            style={{
              justifyContent: "center",
              alignItems: "flex-end",
              display: "flex",
            }}
          >
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_14,
                {
                  color: "white",
                  marginVertical: 10,
                },
              ]}
            >
              Forgot Password?
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={{
              height: 40,
              marginTop: 10,
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: AppColors.themeColor_0A89AD,
              marginHorizontal: "20%",
              borderRadius: 20,
            }}
            onPress={userLoginAPI}
            disabled={showLoader}
          >
            {showLoader ? (
              <ActivityIndicator color={AppColors.white} />
            ) : (
              <Text style={[AppFontStyle.BOLD_ANYBODY_14]}>Login</Text>
            )}
          </TouchableOpacity>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              marginVertical: 20,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_12,
                {
                  color: "white",
                },
              ]}
            >
              Don't have an account?{" "}
            </Text>
            <TouchableOpacity
              onPress={() => {
                setModalType("signup"); // Switch to signup modal
              }}
              style={{ cursor: "pointer" }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_14,
                  {
                    color: "white",
                  },
                ]}
              >
                {" "}
                Sign Up{" "}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </TouchableWithoutFeedback>
    </View>
  );
};

// const useStyles = CreateResponsiveStyle({

// }

export default LoginForm;
